import React from 'react';
import ReactDOM from 'react-dom';

import PropTypes from 'prop-types';

class TogglableContainer extends React.PureComponent {
    state = {
        isOpen: this.props.isOpen || false,
    };

    handleToggle = () => {
        this.setIsOpen();
    };

    setIsOpen = (isOutsideClick) => {
        this.setState(({ isOpen }) => {
            if (isOpen && this.props.onClose) {
                this.props.onClose();
            }
            return {
                isOpen: isOutsideClick ? false : !isOpen,
            };
        });
    };

    handleClickOutside = () => {
        const { noClickOutside } = this.props;
        if (!noClickOutside) {
            this.setIsOpen(true);
        }
    };

    componentDidMount() {
        document.addEventListener('click', this.handleClick, true);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClick, true);
    }

    getRef = () => {
        if (!this.node) {
            this.node = React.createRef();
        }
        return this.node;
    };

    handleClick = (e) => {
        if (this.node) {
            const domNode = ReactDOM.findDOMNode(this.node.current);
            if (domNode && domNode.contains(e.target)) {
                return;
            }
        }
        this.handleClickOutside();
    };

    render() {
        const { children, ...rest } = this.props;
        const { isOpen } = this.state;
        return children({
            ...rest,
            isOpen,
            handleToggle: this.handleToggle,
            forwardedRef: this.getRef(),
        });
    }
}

export const Togglable = TogglableContainer;

Togglable.propTypes = {
    noClickOutside: PropTypes.bool,
    onClose: PropTypes.func,
};
